module.exports = {
	"small_airplane": "airplane_small",
	"right_anger_bubble": "anger_right",
	"keycap_asterisk": "asterisk",
	"atom_symbol": "atom",
	"ballot_box_with_ballot": "ballot_box",
	"person_with_ball": "basketball_player",
	"person_with_ball_tone1": "basketball_player_tone1",
	"person_with_ball_tone2": "basketball_player_tone2",
	"person_with_ball_tone3": "basketball_player_tone3",
	"person_with_ball_tone4": "basketball_player_tone4",
	"person_with_ball_tone5": "basketball_player_tone5",
	"beach_with_umbrella": "beach",
	"umbrella_on_ground": "beach_umbrella",
	"bellhop_bell": "bellhop",
	"biohazard_sign": "biohazard",
	"archery": "bow_and_arrow",
	"boxing_gloves": "boxing_glove",
	"spiral_calendar_pad": "calendar_spiral",
	"call_me_hand": "call_me",
	"call_me_hand_tone1": "call_me_tone1",
	"call_me_hand_tone2": "call_me_tone2",
	"call_me_hand_tone3": "call_me_tone3",
	"call_me_hand_tone4": "call_me_tone4",
	"call_me_hand_tone5": "call_me_tone5",
	"kayak": "canoe",
	"card_file_box": "card_box",
	"person_doing_cartwheel": "cartwheel",
	"person_doing_cartwheel_tone1": "cartwheel_tone1",
	"person_doing_cartwheel_tone2": "cartwheel_tone2",
	"person_doing_cartwheel_tone3": "cartwheel_tone3",
	"person_doing_cartwheel_tone4": "cartwheel_tone4",
	"person_doing_cartwheel_tone5": "cartwheel_tone5",
	"bottle_with_popping_cork": "champagne",
	"clinking_glass": "champagne_glass",
	"cheese_wedge": "cheese",
	"city_sunrise": "city_sunset",
	"mantlepiece_clock": "clock",
	"cloud_with_lightning": "cloud_lightning",
	"cloud_with_rain": "cloud_rain",
	"cloud_with_snow": "cloud_snow",
	"cloud_with_tornado": "cloud_tornado",
	"clown_face": "clown",
	"building_construction": "construction_site",
	"couch_and_lamp": "couch",
	"couple_with_heart_mm": "couple_mm",
	"couple_with_heart_ww": "couple_ww",
	"face_with_cowboy_hat": "cowboy",
	"lower_left_crayon": "crayon",
	"cricket_bat_ball": "cricket",
	"latin_cross": "cross",
	"passenger_ship": "cruise_ship",
	"dagger_knife": "dagger",
	"desktop_computer": "desktop",
	"card_index_dividers": "dividers",
	"dove_of_peace": "dove",
	"drool": "drooling_face",
	"drum_with_drumsticks": "drum",
	"email": "e-mail",
	"eject_symbol": "eject",
	"facepalm": "face_palm",
	"facepalm_tone1": "face_palm_tone1",
	"facepalm_tone2": "face_palm_tone2",
	"facepalm_tone3": "face_palm_tone3",
	"facepalm_tone4": "face_palm_tone4",
	"facepalm_tone5": "face_palm_tone5",
	"fencing": "fencer",
	"hand_with_index_and_middle_finger_crossed": "fingers_crossed",
	"hand_with_index_and_middle_fingers_crossed_tone1": "fingers_crossed_tone1",
	"hand_with_index_and_middle_fingers_crossed_tone2": "fingers_crossed_tone2",
	"hand_with_index_and_middle_fingers_crossed_tone3": "fingers_crossed_tone3",
	"hand_with_index_and_middle_fingers_crossed_tone4": "fingers_crossed_tone4",
	"hand_with_index_and_middle_fingers_crossed_tone5": "fingers_crossed_tone5",
	"flame": "fire",
	"first_place_medal": "first_place",
	"ac": "flag_ac",
	"ad": "flag_ad",
	"ae": "flag_ae",
	"af": "flag_af",
	"ag": "flag_ag",
	"ai": "flag_ai",
	"al": "flag_al",
	"am": "flag_am",
	"ao": "flag_ao",
	"aq": "flag_aq",
	"ar": "flag_ar",
	"as": "flag_as",
	"at": "flag_at",
	"au": "flag_au",
	"aw": "flag_aw",
	"ax": "flag_ax",
	"az": "flag_az",
	"ba": "flag_ba",
	"bb": "flag_bb",
	"bd": "flag_bd",
	"be": "flag_be",
	"bf": "flag_bf",
	"bg": "flag_bg",
	"bh": "flag_bh",
	"bi": "flag_bi",
	"bj": "flag_bj",
	"bl": "flag_bl",
	"waving_black_flag": "flag_black",
	"bm": "flag_bm",
	"bn": "flag_bn",
	"bo": "flag_bo",
	"bq": "flag_bq",
	"br": "flag_br",
	"bs": "flag_bs",
	"bt": "flag_bt",
	"bv": "flag_bv",
	"bw": "flag_bw",
	"by": "flag_by",
	"bz": "flag_bz",
	"ca": "flag_ca",
	"cc": "flag_cc",
	"congo": "flag_cd",
	"cf": "flag_cf",
	"cg": "flag_cg",
	"ch": "flag_ch",
	"ci": "flag_ci",
	"ck": "flag_ck",
	"chile": "flag_cl",
	"cm": "flag_cm",
	"cn": "flag_cn",
	"co": "flag_co",
	"cp": "flag_cp",
	"cr": "flag_cr",
	"cu": "flag_cu",
	"cv": "flag_cv",
	"cw": "flag_cw",
	"cx": "flag_cx",
	"cy": "flag_cy",
	"cz": "flag_cz",
	"de": "flag_de",
	"dg": "flag_dg",
	"dj": "flag_dj",
	"dk": "flag_dk",
	"dm": "flag_dm",
	"do": "flag_do",
	"dz": "flag_dz",
	"ea": "flag_ea",
	"ec": "flag_ec",
	"ee": "flag_ee",
	"eg": "flag_eg",
	"eh": "flag_eh",
	"er": "flag_er",
	"es": "flag_es",
	"et": "flag_et",
	"eu": "flag_eu",
	"fi": "flag_fi",
	"fj": "flag_fj",
	"fk": "flag_fk",
	"fm": "flag_fm",
	"fo": "flag_fo",
	"fr": "flag_fr",
	"ga": "flag_ga",
	"gb": "flag_gb",
	"gd": "flag_gd",
	"ge": "flag_ge",
	"gf": "flag_gf",
	"gg": "flag_gg",
	"gh": "flag_gh",
	"gi": "flag_gi",
	"gl": "flag_gl",
	"gm": "flag_gm",
	"gn": "flag_gn",
	"gp": "flag_gp",
	"gq": "flag_gq",
	"gr": "flag_gr",
	"gs": "flag_gs",
	"gt": "flag_gt",
	"gu": "flag_gu",
	"gw": "flag_gw",
	"gy": "flag_gy",
	"hk": "flag_hk",
	"hm": "flag_hm",
	"hn": "flag_hn",
	"hr": "flag_hr",
	"ht": "flag_ht",
	"hu": "flag_hu",
	"ic": "flag_ic",
	"indonesia": "flag_id",
	"ie": "flag_ie",
	"il": "flag_il",
	"im": "flag_im",
	"in": "flag_in",
	"io": "flag_io",
	"iq": "flag_iq",
	"ir": "flag_ir",
	"is": "flag_is",
	"it": "flag_it",
	"je": "flag_je",
	"jm": "flag_jm",
	"jo": "flag_jo",
	"jp": "flag_jp",
	"ke": "flag_ke",
	"kg": "flag_kg",
	"kh": "flag_kh",
	"ki": "flag_ki",
	"km": "flag_km",
	"kn": "flag_kn",
	"kp": "flag_kp",
	"kr": "flag_kr",
	"kw": "flag_kw",
	"ky": "flag_ky",
	"kz": "flag_kz",
	"la": "flag_la",
	"lb": "flag_lb",
	"lc": "flag_lc",
	"li": "flag_li",
	"lk": "flag_lk",
	"lr": "flag_lr",
	"ls": "flag_ls",
	"lt": "flag_lt",
	"lu": "flag_lu",
	"lv": "flag_lv",
	"ly": "flag_ly",
	"ma": "flag_ma",
	"mc": "flag_mc",
	"md": "flag_md",
	"me": "flag_me",
	"mf": "flag_mf",
	"mg": "flag_mg",
	"mh": "flag_mh",
	"mk": "flag_mk",
	"ml": "flag_ml",
	"mm": "flag_mm",
	"mn": "flag_mn",
	"mo": "flag_mo",
	"mp": "flag_mp",
	"mq": "flag_mq",
	"mr": "flag_mr",
	"ms": "flag_ms",
	"mt": "flag_mt",
	"mu": "flag_mu",
	"mv": "flag_mv",
	"mw": "flag_mw",
	"mx": "flag_mx",
	"my": "flag_my",
	"mz": "flag_mz",
	"na": "flag_na",
	"nc": "flag_nc",
	"ne": "flag_ne",
	"nf": "flag_nf",
	"nigeria": "flag_ng",
	"ni": "flag_ni",
	"nl": "flag_nl",
	"no": "flag_no",
	"np": "flag_np",
	"nr": "flag_nr",
	"nu": "flag_nu",
	"nz": "flag_nz",
	"om": "flag_om",
	"pa": "flag_pa",
	"pe": "flag_pe",
	"pf": "flag_pf",
	"pg": "flag_pg",
	"ph": "flag_ph",
	"pk": "flag_pk",
	"pl": "flag_pl",
	"pm": "flag_pm",
	"pn": "flag_pn",
	"pr": "flag_pr",
	"ps": "flag_ps",
	"pt": "flag_pt",
	"pw": "flag_pw",
	"py": "flag_py",
	"qa": "flag_qa",
	"re": "flag_re",
	"ro": "flag_ro",
	"rs": "flag_rs",
	"ru": "flag_ru",
	"rw": "flag_rw",
	"saudiarabia": "flag_sa",
	"saudi": "flag_sa",
	"sb": "flag_sb",
	"sc": "flag_sc",
	"sd": "flag_sd",
	"se": "flag_se",
	"sg": "flag_sg",
	"sh": "flag_sh",
	"si": "flag_si",
	"sj": "flag_sj",
	"sk": "flag_sk",
	"sl": "flag_sl",
	"sm": "flag_sm",
	"sn": "flag_sn",
	"so": "flag_so",
	"sr": "flag_sr",
	"ss": "flag_ss",
	"st": "flag_st",
	"sv": "flag_sv",
	"sx": "flag_sx",
	"sy": "flag_sy",
	"sz": "flag_sz",
	"ta": "flag_ta",
	"tc": "flag_tc",
	"td": "flag_td",
	"tf": "flag_tf",
	"tg": "flag_tg",
	"th": "flag_th",
	"tj": "flag_tj",
	"tk": "flag_tk",
	"tl": "flag_tl",
	"turkmenistan": "flag_tm",
	"tn": "flag_tn",
	"to": "flag_to",
	"tr": "flag_tr",
	"tt": "flag_tt",
	"tuvalu": "flag_tv",
	"tw": "flag_tw",
	"tz": "flag_tz",
	"ua": "flag_ua",
	"ug": "flag_ug",
	"um": "flag_um",
	"us": "flag_us",
	"uy": "flag_uy",
	"uz": "flag_uz",
	"va": "flag_va",
	"vc": "flag_vc",
	"ve": "flag_ve",
	"vg": "flag_vg",
	"vi": "flag_vi",
	"vn": "flag_vn",
	"vu": "flag_vu",
	"wf": "flag_wf",
	"waving_white_flag": "flag_white",
	"ws": "flag_ws",
	"xk": "flag_xk",
	"ye": "flag_ye",
	"yt": "flag_yt",
	"za": "flag_za",
	"zm": "flag_zm",
	"zw": "flag_zw",
	"fork_and_knife_with_plate": "fork_knife_plate",
	"fox_face": "fox",
	"frame_with_picture": "frame_photo",
	"baguette_bread": "french_bread",
	"anguished": "frowning",
	"white_frowning_face": "frowning2",
	"goal_net": "goal",
	"hammer_and_pick": "hammer_pick",
	"raised_hand_with_fingers_splayed": "hand_splayed",
	"raised_hand_with_fingers_splayed_tone1": "hand_splayed_tone1",
	"raised_hand_with_fingers_splayed_tone2": "hand_splayed_tone2",
	"raised_hand_with_fingers_splayed_tone3": "hand_splayed_tone3",
	"raised_hand_with_fingers_splayed_tone4": "hand_splayed_tone4",
	"raised_hand_with_fingers_splayed_tone5": "hand_splayed_tone5",
	"shaking_hands": "handshake",
	"shaking_hands_tone1": "handshake_tone1",
	"shaking_hands_tone2": "handshake_tone2",
	"shaking_hands_tone3": "handshake_tone3",
	"shaking_hands_tone4": "handshake_tone4",
	"shaking_hands_tone5": "handshake_tone5",
	"face_with_head_bandage": "head_bandage",
	"heavy_heart_exclamation_mark_ornament": "heart_exclamation",
	"helmet_with_white_cross": "helmet_with_cross",
	"house_buildings": "homes",
	"hot_dog": "hotdog",
	"derelict_house_building": "house_abandoned",
	"hugging_face": "hugging",
	"desert_island": "island",
	"juggler": "juggling",
	"juggler_tone1": "juggling_tone1",
	"juggler_tone2": "juggling_tone2",
	"juggler_tone3": "juggling_tone3",
	"juggler_tone4": "juggling_tone4",
	"juggler_tone5": "juggling_tone5",
	"old_key": "key2",
	"couplekiss_mm": "kiss_mm",
	"couplekiss_ww": "kiss_ww",
	"kiwifruit": "kiwi",
	"satisfied": "laughing",
	"left_fist": "left_facing_fist",
	"left_fist_tone1": "left_facing_fist_tone1",
	"left_fist_tone2": "left_facing_fist_tone2",
	"left_fist_tone3": "left_facing_fist_tone3",
	"left_fist_tone4": "left_facing_fist_tone4",
	"left_fist_tone5": "left_facing_fist_tone5",
	"man_in_business_suit_levitating": "levitate",
	"weight_lifter": "lifter",
	"weight_lifter_tone1": "lifter_tone1",
	"weight_lifter_tone2": "lifter_tone2",
	"weight_lifter_tone3": "lifter_tone3",
	"weight_lifter_tone4": "lifter_tone4",
	"weight_lifter_tone5": "lifter_tone5",
	"lion": "lion_face",
	"liar": "lying_face",
	"male_dancer": "man_dancing",
	"male_dancer_tone1": "man_dancing_tone1",
	"male_dancer_tone2": "man_dancing_tone2",
	"male_dancer_tone3": "man_dancing_tone3",
	"male_dancer_tone4": "man_dancing_tone4",
	"male_dancer_tone5": "man_dancing_tone5",
	"tuxedo_tone1": "man_in_tuxedo_tone1",
	"tuxedo_tone2": "man_in_tuxedo_tone2",
	"tuxedo_tone3": "man_in_tuxedo_tone3",
	"tuxedo_tone4": "man_in_tuxedo_tone4",
	"tuxedo_tone5": "man_in_tuxedo_tone5",
	"world_map": "map",
	"karate_uniform": "martial_arts_uniform",
	"sports_medal": "medal",
	"sign_of_the_horns": "metal",
	"sign_of_the_horns_tone1": "metal_tone1",
	"sign_of_the_horns_tone2": "metal_tone2",
	"sign_of_the_horns_tone3": "metal_tone3",
	"sign_of_the_horns_tone4": "metal_tone4",
	"sign_of_the_horns_tone5": "metal_tone5",
	"studio_microphone": "microphone2",
	"reversed_hand_with_middle_finger_extended": "middle_finger",
	"reversed_hand_with_middle_finger_extended_tone1": "middle_finger_tone1",
	"reversed_hand_with_middle_finger_extended_tone2": "middle_finger_tone2",
	"reversed_hand_with_middle_finger_extended_tone3": "middle_finger_tone3",
	"reversed_hand_with_middle_finger_extended_tone4": "middle_finger_tone4",
	"reversed_hand_with_middle_finger_extended_tone5": "middle_finger_tone5",
	"glass_of_milk": "milk",
	"money_mouth_face": "money_mouth",
	"motorbike": "motor_scooter",
	"racing_motorcycle": "motorcycle",
	"snow_capped_mountain": "mountain_snow",
	"three_button_mouse": "mouse_three_button",
	"mother_christmas": "mrs_claus",
	"mother_christmas_tone1": "mrs_claus_tone1",
	"mother_christmas_tone2": "mrs_claus_tone2",
	"mother_christmas_tone3": "mrs_claus_tone3",
	"mother_christmas_tone4": "mrs_claus_tone4",
	"mother_christmas_tone5": "mrs_claus_tone5",
	"sick": "nauseated_face",
	"nerd_face": "nerd",
	"rolled_up_newspaper": "newspaper2",
	"spiral_note_pad": "notepad_spiral",
	"stop_sign": "octagonal_sign",
	"oil_drum": "oil",
	"grandma": "older_woman",
	"grandma_tone1": "older_woman_tone1",
	"grandma_tone2": "older_woman_tone2",
	"grandma_tone3": "older_woman_tone3",
	"grandma_tone4": "older_woman_tone4",
	"grandma_tone5": "older_woman_tone5",
	"lower_left_paintbrush": "paintbrush",
	"linked_paperclips": "paperclips",
	"national_park": "park",
	"double_vertical_bar": "pause_button",
	"peace_symbol": "peace",
	"shelled_peanut": "peanuts",
	"lower_left_ballpoint_pen": "pen_ballpoint",
	"lower_left_fountain_pen": "pen_fountain",
	"memo": "pencil",
	"table_tennis": "ping_pong",
	"worship_symbol": "place_of_worship",
	"shit": "poop",
	"hankey": "poop",
	"poo": "poop",
	"expecting_woman": "pregnant_woman",
	"expecting_woman_tone1": "pregnant_woman_tone1",
	"expecting_woman_tone2": "pregnant_woman_tone2",
	"expecting_woman_tone3": "pregnant_woman_tone3",
	"expecting_woman_tone4": "pregnant_woman_tone4",
	"expecting_woman_tone5": "pregnant_woman_tone5",
	"film_projector": "projector",
	"racing_car": "race_car",
	"radioactive_sign": "radioactive",
	"railroad_track": "railway_track",
	"back_of_hand": "raised_back_of_hand",
	"back_of_hand_tone1": "raised_back_of_hand_tone1",
	"back_of_hand_tone2": "raised_back_of_hand_tone2",
	"back_of_hand_tone3": "raised_back_of_hand_tone3",
	"back_of_hand_tone4": "raised_back_of_hand_tone4",
	"back_of_hand_tone5": "raised_back_of_hand_tone5",
	"rhinoceros": "rhino",
	"right_fist": "right_facing_fist",
	"right_fist_tone1": "right_facing_fist_tone1",
	"right_fist_tone2": "right_facing_fist_tone2",
	"right_fist_tone3": "right_facing_fist_tone3",
	"right_fist_tone4": "right_facing_fist_tone4",
	"right_fist_tone5": "right_facing_fist_tone5",
	"robot_face": "robot",
	"rolling_on_the_floor_laughing": "rofl",
	"face_with_rolling_eyes": "rolling_eyes",
	"green_salad": "salad",
	"second_place_medal": "second_place",
	"paella": "shallow_pan_of_food",
	"shopping_trolley": "shopping_cart",
	"skeleton": "skull",
	"skull_and_crossbones": "skull_crossbones",
	"slightly_frowning_face": "slight_frown",
	"slightly_smiling_face": "slight_smile",
	"sneeze": "sneezing_face",
	"speaking_head_in_silhouette": "speaking_head",
	"sleuth_or_spy": "spy",
	"sleuth_or_spy_tone1": "spy_tone1",
	"sleuth_or_spy_tone2": "spy_tone2",
	"sleuth_or_spy_tone3": "spy_tone3",
	"sleuth_or_spy_tone4": "spy_tone4",
	"sleuth_or_spy_tone5": "spy_tone5",
	"stuffed_pita": "stuffed_flatbread",
	"face_with_thermometer": "thermometer_face",
	"thinking_face": "thinking",
	"third_place_medal": "third_place",
	"-1": "thumbsdown",
	"-1_tone1": "thumbsdown_tone1",
	"-1_tone2": "thumbsdown_tone2",
	"-1_tone3": "thumbsdown_tone3",
	"-1_tone4": "thumbsdown_tone4",
	"-1_tone5": "thumbsdown_tone5",
	"+1": "thumbsup",
	"+1_tone1": "thumbsup_tone1",
	"+1_tone2": "thumbsup_tone2",
	"+1_tone3": "thumbsup_tone3",
	"+1_tone4": "thumbsup_tone4",
	"+1_tone5": "thumbsup_tone5",
	"thunder_cloud_and_rain": "thunder_cloud_rain",
	"admission_tickets": "tickets",
	"timer_clock": "timer",
	"hammer_and_wrench": "tools",
	"next_track": "track_next",
	"previous_track": "track_previous",
	"whisky": "tumbler_glass",
	"unicorn_face": "unicorn",
	"upside_down_face": "upside_down",
	"funeral_urn": "urn",
	"raised_hand_with_part_between_middle_and_ring_fingers": "vulcan",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone1": "vulcan_tone1",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone2": "vulcan_tone2",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone3": "vulcan_tone3",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone4": "vulcan_tone4",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone5": "vulcan_tone5",
	"white_sun_behind_cloud": "white_sun_cloud",
	"white_sun_behind_cloud_with_rain": "white_sun_rain_cloud",
	"white_sun_with_small_cloud": "white_sun_small_cloud",
	"wilted_flower": "wilted_rose",
	"wrestling": "wrestlers",
	"wrestling_tone1": "wrestlers_tone1",
	"wrestling_tone2": "wrestlers_tone2",
	"wrestling_tone3": "wrestlers_tone3",
	"wrestling_tone4": "wrestlers_tone4",
	"wrestling_tone5": "wrestlers_tone5",
	"zipper_mouth_face": "zipper_mouth"
};


//////////////////
// WEBPACK FOOTER
// /home/git/gitlab/fixtures/emojis/aliases.json
// module id = 230
// module chunks = 0